import React from "react";
import cn from "classnames";
import * as styles from "./HeaderMain.module.scss";
import HeaderMainMenu from "../HeaderMainMenu/HeaderMainMenu";

function HeaderMain() {
  return (
    <>
      <header
        className={cn(
          styles.root
        )}
      >
        <HeaderMainMenu />
      </header>
    </>
  );
}

export default HeaderMain;
